import React from 'react';
import i18n from '../../../i18n';
import type { ConnectedSourceId } from '../types';
import { Icon } from './shared/Icon';
import { DrillToolbar } from './shared/DrillToolbar';
import { DrillMetricTabs, type DrillTabDef } from './shared/DrillMetricTabs';

/** Failed drill request: what happened and a retry, in place of the charts. */
export function DrillLoadError({
  title = i18n.t('performance:drillUi.loadFailedTitle'),
  body = i18n.t('performance:drillUi.loadFailedBody'),
  onRetry,
}: {
  title?: string;
  body?: string;
  onRetry?: () => void;
}) {
  return (
    <section className="ddrill-error" role="alert">
      <span className="ddrill-error-ic" aria-hidden>
        <Icon name="info" size={18} />
      </span>
      <div className="ddrill-error-copy">
        <h3>{title}</h3>
        <p>{body}</p>
      </div>
      {onRetry ? (
        <button type="button" className="ddrill-error-retry" onClick={onRetry}>
          <Icon name="refresh" size={13} />
          {i18n.t('performance:drillUi.retry')}
        </button>
      ) : null}
    </section>
  );
}

/** Drill shell (toolbar with close and tabs) around a load error. */
export function DrillErrorOverlay({
  onClose,
  onRetry,
  belowTopbar = false,
  periodLabel,
  activeMetric,
  reviewsAvailable,
  connected,
  onSwitchMetric,
  'data-ftue': dataFtue,
}: {
  onClose: () => void;
  onRetry: () => void;
  belowTopbar?: boolean;
  periodLabel?: string;
  activeMetric?: string;
  reviewsAvailable?: boolean;
  connected?: ConnectedSourceId[];
  onSwitchMetric?: (tab: DrillTabDef) => void;
  'data-ftue'?: string;
}) {
  return (
    <div
      className={`drill drill-error${belowTopbar ? ' drill-below-topbar' : ''}`}
      data-ftue={dataFtue}
    >
      <DrillToolbar onClose={onClose} periodLabel={periodLabel}>
        {activeMetric && onSwitchMetric ? (
          <DrillMetricTabs
            active={activeMetric}
            reviewsAvailable={reviewsAvailable}
            connected={connected}
            onSelect={onSwitchMetric}
          />
        ) : null}
      </DrillToolbar>
      <div className="drill-body">
        <DrillLoadError onRetry={onRetry} />
      </div>
    </div>
  );
}
